import React, { useEffect, useRef, useState } from 'react';

import styled from 'styled-components';

// AI 토큰 사용량 게이지 — usagePercent(0~100)만 받아 바 + 롤링 퍼센트로 표시 //
// 색상 분기: 80% 미만 정상 / 80~90% 경고(주황) / 90% 이상 위험(빨강) //
const WARN_COLOR = '#F5A623';
const DANGER_COLOR = '#E5383B';

function resolveColor(percent, normalColor) {
  if (percent >= 90) return DANGER_COLOR;
  if (percent >= 80) return WARN_COLOR;
  return normalColor;
}

export default function TokenUsageGauge({ usagePercent = 0, normalColor, trackColor }) {
  const clamped = Math.max(0, Math.min(100, Math.round(usagePercent)));

  // 롤링 넘버 — 직전 표시값에서 새 값까지 카운트업(ease-out) //
  const [displayPercent, setDisplayPercent] = useState(clamped);
  const displayRef = useRef(clamped);

  useEffect(() => {
    const from = displayRef.current;
    const to = clamped;
    if (from === to) return;

    const duration = 800;
    let startTs = null;
    let raf = null;

    function step(ts) {
      if (startTs === null) startTs = ts;

      const progress = Math.min(1, (ts - startTs) / duration);
      const eased = 1 - Math.pow(1 - progress, 3);
      const value = Math.round(from + (to - from) * eased);

      displayRef.current = value;
      setDisplayPercent(value);

      if (progress < 1) raf = requestAnimationFrame(step);
    }

    raf = requestAnimationFrame(step);

    return () => { if (raf) cancelAnimationFrame(raf); };
  }, [clamped]);

  const color = resolveColor(clamped, normalColor);

  return (
    <GaugeWrapper>
      <Track $bg={trackColor}>
        <Fill $percent={clamped} $color={color} />
      </Track>
      <Percent $color={color}>{displayPercent}%</Percent>
    </GaugeWrapper>
  );
}

const GaugeWrapper = styled.div`
  display: flex;

  justify-content: center;
  align-items: center;

  gap: 8px;
`;

const Track = styled.div`
  position: relative;

  width: 90px;
  height: 8px;

  border-radius: 4px;
  background-color: ${props => props.$bg};

  overflow: hidden;
`;

const Fill = styled.div`
  height: 100%;
  width: ${props => props.$percent}%;

  border-radius: 4px;
  background-color: ${props => props.$color};

  transition: width 0.8s ease, background-color 0.4s ease;
`;

const Percent = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.$color};

  margin: 0;

  min-width: 34px;
  text-align: right;
`;
